/* eslint-disable */

import Vue       from "vue";
import Vuex      from "vuex";
import Inputmask from "inputmask";

Vue.use(Vuex);
import store     from "./store";

let patchTemplate = "/local/templates/terbiz2022/vue-terbiz/";

// Vue.component('inn-search', () => import('./components/InnSearch'));
// import PopupMessage from './components/PopupMessage.vue';

Vue.component("popup-message", () => import("./components/PopupMessage.vue"));
Vue.component("registration-form", () => import("./components/RegistrationForm"));
//Vue.component('events-calendar', () => import('./components/EventsCalendar'));
Vue.component("events-calendar2022", () => import("./components/EventsCalendar2022"));
Vue.component('available-support', () => import('./components/AvailableSupport'));
//Vue.component('btn-more', () => import('./components/BtnMore'));
Vue.component("yandex-map", () => import("./components/YandexMap"));
//Vue.component('calc', () => import('./components/Calc'));
Vue.component("agro-test", () => import("./components/AgroTest"));

//import SearchAutocomplete from './components/SearchAutocomplete.vue';
//Vue.component('search-autocomplete', SearchAutocomplete);

Vue.component("news-section", () => import("./components/News/NewsSection.vue"));
Vue.component("news-item", () => import("./components/News/NewsItem.vue"));
Vue.component("news-filter", () => import("./components/News/NewsFilter.vue"));
Vue.component("search-results", () => import("./components/Search/SearchResults.vue"));

Vue.component("translation-list", () => import("./components/Translation/TranslationList.vue"));
Vue.component("translation-item", () => import("./components/Translation/TranslationItem.vue"));
Vue.component("translation-filter", () => import("./components/Translation/TranslationFilter.vue"));

Vue.component("translation-votes", () => import("./components/Translation/Votes.vue"));
Vue.component("komplex-service-add", () => import("./components/KomplexServiceAdd.vue"));


document.addEventListener('DOMContentLoaded',()=>{
    window.app = new Vue({
        el : "#app-container",
        store,
        data()
        {
            return {
                cityListDadata : [],
                cityListDadataFilter : [],
                isValidInnInput : false,
                start : false
            }
        },
        mounted()
        {
            if(typeof (xpageReady) == "function")
            {
                xpageReady();
            }

            if(typeof (initUI) == "function")
            {
                window.initUI();
            }
            if(this.$root.$refs.innInput) {
                this.validInnInput(this.$root.$refs.innInput);
            }
            this.start = true;
        },
        computed : {
            reachedYaCounterGoalId()
            {
                return this.$store.state.reachedYaCounterGoalId;
            }
        },
        watch    : {
            reachedYaCounterGoalId( goalId, oldVal )
            {
                if(goalId)
                {
                    if(typeof (window.yaCounter44802325) != "undefined")
                    {
                        window.yaCounter44802325.reachGoal(goalId);
                    }
                    else
                    {
                        /*$(document).on('yacounter44802325inited', () => {
                         window.yaCounter44802325.reachGoal(goalId);
                         });*/
                    }
                }
            }
        },
        methods  : {
            initMap( callback )
            {
                if(!window.ymaps)
                {
                    var script = document.createElement("script");
                    script.src = "https://api-maps.yandex.ru/2.1/?lang=ru_RU";
                    if(typeof (callback) == "function")
                    {
                        script.onload = callback;
                    }
                    document.body.appendChild(script);
                }
                else
                {
                    if(typeof (callback) == "function")
                    {
                        callback();
                    }
                }
            },
            setServices( name, idProp )
            {
                if(idProp)
                {
                    document.getElementById("property-form-" + idProp).value = name;
                }
            },
            setServicesObj( obj )
            {
                for (let idProp in obj){
                    if(document.getElementById("property-form-" + idProp)) {
                        document.getElementById("property-form-" + idProp).value = obj[idProp];
                    }
                    if(idProp == 1219 && this.$refs && this.$refs.forms272){
                        this.$refs.forms272.idService = obj[idProp];

                    }
                }
            },
            checkSelectValidity( el )
            {
                if(!el.value)
                {
                    el.classList.add("error");
                    if(el.parentElement.classList.contains("default-select")) {
                        el.parentElement.classList.add("error");
                    }
                    return false;
                }
                else
                {
                    el.classList.remove("error");
                    if(el.parentElement.classList.contains("default-select")) {
                        el.parentElement.classList.remove("error");
                    }
                    return true;
                }
            },

            checkValidity( el )
            {
                if(!el.checkValidity())
                {
                    el.classList.add("default-input__input--error");
                    if(el.parentElement.classList.contains("default-file")) {
                        el.parentElement.classList.add("default-file--error");
                    }
                    if(el.parentElement.classList.contains("default-select")) {
                        el.parentElement.classList.add("error");
                    }
                    //input.parentElement.querySelector('.default-input__error').innerHTML='Обязательное поле';
                    return false;
                }
                else
                {
                    if(el.type == "file")
                    {

                        let fileInput = el;
                        if(fileInput && fileInput.files.length && fileInput.files[0])
                        {
                            Array.from(fileInput.files).forEach(( file ) =>
                                {
                                    if(file.size > 5 * 1024 * 1024)
                                    {
                                        // alert("Размер файла более 5 Мб.");
                                        // fileInput.closest('div').getElementsByClassName('default-file__placeholder')[0].textContent = '';
                                        // fileInput.value = "";
                                        el.classList.add("default-input__input--error");
                                        el.parentElement.classList.add("default-file--error");
                                        return false;
                                    }

                                    let allowExp = [
                                        "jpg",
                                        "pdf",
                                        "png"
                                    ];

                                    let parts = file.name.split(".");
                                    if(!allowExp.includes(parts.pop()))
                                    {
                                        // alert("Формат документа \"" + parts.pop() + "\" не соответствует возможному для загрузки");
                                        // fileInput.closest('div').getElementsByClassName('default-file__placeholder')[0].textContent = '';
                                        // fileInput.value = "";
                                        el.classList.add("default-input__input--error");
                                        if(el.parentElement.classList.contains("default-file")) {
                                            el.parentElement.classList.add("default-file--error");
                                        }
                                        return false;
                                    }
                                    el.classList.remove("default-input__input--error");
                                    if(el.parentElement.classList.contains("default-file")) {
                                        el.parentElement.classList.remove("default-file--error");
                                    }
                                }
                            );
                        }

                    }
                    else if(el.classList.contains("mask--phone"))
                    {

                        let phone = (el.value).replace(/[_()\-+ ]/gim, "");
                        if(phone.length !== 11)
                        {
                            el.classList.add("default-input__input--error");
                            return false;
                        }
                        else
                        {
                            el.classList.remove("default-input__input--error");
                        }
                    }
                    else if(el.classList.contains("input__inn"))
                    {

                        let inn  = (el.value).replace(/[_()\-+ ]/gim, "");
                        el.value = inn.substring(0, 12);
                        inn      = el.value;
                        if(inn.length !== 10 && inn.length !== 12)
                        {
                            el.classList.add("default-input__input--error");
                            return false;
                        }
                    }
                    else
                    {
                        el.classList.remove("default-input__input--error");
                        if(el.parentElement.classList.contains("default-file")) {
                            el.parentElement.classList.remove("default-file--error");
                        }
                        if(el.parentElement.classList.contains("default-select")) {
                            el.parentElement.classList.add("error");
                        }
                    }
                }
                return true;
            },
            removeErrorClass( el )
            {
                el.classList.remove("default-input__input--error");
                if(el.parentElement.classList.contains("default-file")) {
                    el.parentElement.classList.remove("default-file--error");
                }
                if(el.parentElement.classList.contains("default-select")) {
                    el.parentElement.classList.add("error");
                }

            },
            checkForm()
            {

                let form = event.target.closest("form");

                let required        = form.querySelectorAll("input[required=\"required\"],textarea[required=\"required\"]");
                let requiredSelects = form.querySelectorAll("select[required=\"required\"]");
                let allow           = true;

                Array.from(required).forEach(input =>
                {

                    if(this.checkValidity(input) === true)
                    {

                    }
                    else
                    {
                        allow = false;
                    }
                });

                Array.from(requiredSelects).forEach(select =>
                {
                    if(!this.checkSelectValidity(select))
                    {
                        allow = false;
                    }
                });

                if(!allow)
                {
                    event.preventDefault();
                    return false;
                }

                let fileInput = form.querySelector("input[type='file']");

                if(fileInput && fileInput.files.length && fileInput.files[0])
                {
                    Array.from(fileInput.files).forEach(( file ) =>
                        {
                            if(file.size > 5 * 1024 * 1024)
                            {
                                // alert("Размер файла более 5 Мб.");
                                // fileInput.closest('div').getElementsByClassName('default-file__placeholder')[0].textContent = '';
                                // fileInput.value = "";
                                allow           = false;
                                return false;
                            }

                            let allowExp = [
                                "jpg",
                                "pdf",
                                "png"
                            ];

                            let parts = file.name.split(".");
                            if(!allowExp.includes(parts.pop()))
                            {
                                // alert("Формат документа \"" + parts.pop() + "\" не соответствует возможному для загрузки");
                                // fileInput.closest('div').getElementsByClassName('default-file__placeholder')[0].textContent = '';
                                // fileInput.value = "";
                                allow = false;
                                return false;
                            }
                        }
                    );
                }


                let innField = form.querySelector("input[name='PROPERTY[437][0]']");
                if(innField)
                {
                    let inn = (innField.value).replace(/[\D]/gim, "");
                    if(inn)
                    {
                        if(inn.length !== 12 && inn.length !== 10)
                        {
                            innField.classList.add("error");
                            //alert('Некорректный ИНН');
                            //$(innField).siblings('.default-input__error').children()[0].textContent = 'Некорректный ИНН';
                            event.preventDefault();
                            return false;
                        }
                    }
                }
                return true;
            },
            checkDateInput() {
                let d = new Date(event.target.value);
                let month = d.getMonth() + 1;
                if(month < 10){ month = "0" + month;}
                let dateField = d.getDate() + "." + month + "." + d.getFullYear();
                event.target.parentNode.querySelector('input.date-hidden').value = dateField;
            },
            openModalDetailText(modalId, name, idProp, idElement)
            {
                let modalInfo = event.target.parentElement.querySelector('.modal-info').innerHTML;
                let modalWindow = document.getElementById(modalId);
                if(modalInfo && modalWindow){
                    modalWindow.querySelector('.text-modal').innerHTML = modalInfo;
                }
                if(modalWindow) {
                    modalWindow.querySelector("#property-form-" + idProp).value = name;
                }
                if(idElement){
                    modalWindow.querySelector('#propFarmerId').value = idElement;
                }
                return true;
            },
            showVideo(videoObj){

                if(!videoObj.id || videoObj.id==""){return false;}

                let id = videoObj.id;

                let el = this.$refs[`video-` + id];

                if(videoObj.player && videoObj.player == "rutube"){

                    let iframe = document.createElement('iframe');
                    iframe.setAttribute('allowfullscreen', '');
                    iframe.setAttribute('webkitAllowFullScreen', '');
                    iframe.setAttribute('mozallowfullscreen', '');
                    iframe.setAttribute('frameBorder', '0');
                    iframe.setAttribute('allow', 'autoplay clipboard-write');
                    iframe.setAttribute('width', '100%');
                    iframe.setAttribute('height', '645');
                    iframe.setAttribute('src',  "https://rutube.ru/play/embed/"+ id);
                    el.innerHTML = "";
                    el.appendChild(iframe);
                }
            },
            getCityListDadata()
            {
                let val = event.target.value;
                let form = event.target.closest('form');
                let bxId = form.querySelector('#sessid_1') ? form.querySelector('#sessid_1').value : null;

                if(val.length == 4 || val.length == 8){

                    let formData           = new FormData;
                    formData.append("ajax_command", "getDadataAddress");
                    formData.append("bxSessId", bxId);
                    formData.append("addressQuery", val);

                    fetch("/local/ajax/ajax.php", {
                        method : "POST",
                        body   : formData
                    })
                        .then(response => response.json())
                        .then(result =>
                        {
                            if(result.cities){
                                this.cityListDadata = result.cities;
                            }

                            this.cityListDadataFilter = this.cityListDadata.filter(i => {
                                const re = new RegExp(val, 'gi');
                                return i.name.match(re);
                            });

                        });
                }else{

                    this.cityListDadataFilter = this.cityListDadata.filter(i => {
                        const re = new RegExp(val, 'gi');
                        return i.name.match(re);
                    });

                }
            },
            setCity(city){
                let form = event.target.closest('form');
                if(form.querySelector('#cityInput')) {
                    form.querySelector('#cityInput').value = city;
                }
            },
            validInnInput(el)
            {
                let val = el.value;
                if(val.length == 10 || val.length == 12){
                    this.isValidInnInput = true;
                }else{
                    this.isValidInnInput = false;
                }
            }
        }
    });
})
